export enum ProfissionalProfissaoTipo {
    Outro = 1,
    Medico = 2,
    Engenheiro = 3,
    Fonoaudiologo = 4,
    Tecnico = 5
}

export interface Usuario {
    nome: string;
    numeroInscricao: string;
    area: string;
    role: string;
    username: string;
    empresaId: number;
    empresasId: string;
    id: number;
    usuarioId: number;
    exp: number;
    iss: string;
    aud: string;
    profissionalId: number;
    profissionalTipoAssinatura: number | null;
    profissionalNome: string;
    profissionalNumeroInscricao: any;
    profissionalConselho: string;
    profissionalProfissaoTipo: ProfissionalProfissaoTipo;
}